module.exports = __webpack_public_path__ + "static/media/like-outline.0c8165b5.svg";